import './App.css';
import { useState, useEffect } from 'react';
import profileImg from './images/linoy-profile.png';
import logoImg from './images/logoLinoy.png';

function App() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // כאן אפשר להוסיף לוגיקה לשליחת הטופס
    alert('ההודעה נשלחה בהצלחה! לינוי תחזור אליכם בהקדם.');
    setFormData({ name: '', phone: '', subject: '', message: '' });
  };

  const whatsappNumber = '972525995052';
  const whatsappMessage = 'היי לינוי, אשמח לשמוע פרטים על שיעורים פרטיים';

  return (
    <div className="App" dir="rtl">
      {/* Navbar */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <a href="#hero" className="navbar-logo" onClick={closeMenu}>
            לינוי חרוש
          </a>

          <button
            className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="תפריט"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
            <li><a href="#hero" onClick={closeMenu}>בית</a></li>
            <li><a href="#about" onClick={closeMenu}>אודות</a></li>
            <li><a href="#services" onClick={closeMenu}>שירותים</a></li>
            <li><a href="#subjects" onClick={closeMenu}>מקצועות</a></li>
            <li><a href="#advantages" onClick={closeMenu}>יתרונות</a></li>
            <li><a href="#testimonials" onClick={closeMenu}>המלצות</a></li>
            <li><a href="#contact" onClick={closeMenu} className="navbar-cta">צרו קשר</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="hero" id="hero">
        <div className="hero-content">
          <div className="profile-image-container">
            <img src={profileImg} alt="לינוי חרוש" className="profile-image" />
          </div>
          <h1>לינוי חרוש</h1>
          <h2>מורה פרטית לאנגלית ומתמטיקה</h2>
          <p className="hero-subtitle">
            ללמוד בקצב שלך, עם יחס אישי ותוצאות אמיתיות
          </p>
          <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
            className="cta-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            📱 דברו איתי בווטסאפ
          </a>
        </div>
      </header>

      {/* About Section */}
      <section className="about" id="about">
        <div className="container">
          <h2>למה ללמוד עם לינוי?</h2>
          <p>
            אני מאמינה שכל תלמיד יכול להצליח כשהוא מקבל את היחס והשיטה הנכונים עבורו.
            עם ניסיון בהוראה פרטית, אני מתמחה בהפיכת חומר מורכב לפשוט ונגיש,
            ובבניית ביטחון עצמי בלימודים.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <div className="container">
          <h2>השירותים שלי</h2>
          <div className="services-grid">
            <div className="service-card">
              <span className="service-icon">📚</span>
              <h3>שיעורים פרטיים</h3>
              <p>שיעורים אישיים בבית התלמיד או אצלי, עם התאמה מלאה לצרכים ולקצב</p>
            </div>
            <div className="service-card">
              <span className="service-icon">💻</span>
              <h3>שיעורים אונליין</h3>
              <p>שיעורים מרחוק בזום או בגוגל מיט, נוחים וגמישים מכל מקום</p>
            </div>
            <div className="service-card">
              <span className="service-icon">📝</span>
              <h3>הכנה למבחנים</h3>
              <p>הכנה ממוקדת לבחינות בגרות, מבחני מחצית ומבחנים בית ספריים</p>
            </div>
            <div className="service-card">
              <span className="service-icon">🎯</span>
              <h3>חיזוק יסודות</h3>
              <p>סגירת פערים וחיזוק הבסיס לתלמידי יסודי ותיכון</p>
            </div>
          </div>
        </div>
      </section>

      {/* Subjects Section */}
      <section className="subjects" id="subjects">
        <div className="container">
          <h2>מקצועות הוראה</h2>
          <div className="subjects-list">
            <div className="subject-item">
              <span className="subject-icon">🔤</span>
              <h3>אנגלית</h3>
              <p>דקדוק, הבנת הנקרא, כתיבה והכנה לבגרות</p>
            </div>
            <div className="subject-item">
              <span className="subject-icon">🔢</span>
              <h3>מתמטיקה</h3>
              <p>אלגברה, גיאומטריה, חשבון ופתרון בעיות</p>
            </div>
            <div className="subject-item">
              <span className="subject-icon">📖</span>
              <h3>הכנה למבחנים</h3>
              <p>אסטרטגיות למידה ותרגול אינטנסיבי</p>
            </div>
            <div className="subject-item">
              <span className="subject-icon">💪</span>
              <h3>בניית ביטחון</h3>
              <p>עבודה על גישה חיובית ללימודים</p>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="advantages" id="advantages">
        <div className="container">
          <h2>היתרונות שלי</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <span className="advantage-icon">🤝</span>
              <h3>סבלנות אינסופית</h3>
              <p>אני חוזרת על החומר כמה פעמים שצריך, עד שזה נכנס</p>
            </div>
            <div className="advantage-item">
              <span className="advantage-icon">📋</span>
              <h3>שיטה ברורה</h3>
              <p>שיטות הוראה מוכחות שעוזרות להבין ולזכור</p>
            </div>
            <div className="advantage-item">
              <span className="advantage-icon">⏰</span>
              <h3>עבודה בקצב התלמיד</h3>
              <p>בלי לחץ, בלי מרוץ - כל אחד מתקדם בקצב שלו</p>
            </div>
            <div className="advantage-item">
              <span className="advantage-icon">💬</span>
              <h3>זמינות גבוהה</h3>
              <p>תמיד אפשר לשאול שאלות גם בין השיעורים</p>
            </div>
            <div className="advantage-item">
              <span className="advantage-icon">🎯</span>
              <h3>התאמה אישית</h3>
              <p>כל תלמיד מקבל תוכנית לימודים מותאמת אישית</p>
            </div>
            <div className="advantage-item">
              <span className="advantage-icon">📈</span>
              <h3>תוצאות מוכחות</h3>
              <p>תלמידים רבים שיפרו את הציונים שלהם משמעותית</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials" id="testimonials">
        <div className="container">
          <h2>מה אומרים עליי</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="testimonial-text">
                "לינוי עזרה לבת שלי לעבור מ-60 ל-85 באנגלית תוך 3 חודשים.
                היא סבלנית, מקצועית ויודעת להתאים את עצמה לכל תלמיד."
              </p>
              <span className="testimonial-author">— מיכל, אמא של תלמידת כיתה י'</span>
            </div>
            <div className="testimonial-card">
              <p className="testimonial-text">
                "סוף סוף מישהי שגרמה לי להבין מתמטיקה!
                לינוי מסבירה בצורה פשוטה וברורה, ותמיד יש לה סבלנות."
              </p>
              <span className="testimonial-author">— יובל, תלמיד כיתה ח'</span>
            </div>
            <div className="testimonial-card">
              <p className="testimonial-text">
                "הבן שלי חזר לאהוב ללמוד בזכות לינוי.
                היא יודעת לעודד ולתת ביטחון, והתוצאות מדברות בעד עצמן."
              </p>
              <span className="testimonial-author">— דני, אבא של תלמיד כיתה ו'</span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact" id="contact">
        <div className="container">
          <h2>צרו קשר</h2>
          <p className="contact-subtitle">השאירו פרטים ואחזור אליכם בהקדם</p>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="שם מלא"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="מספר טלפון"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              >
                <option value="">בחרו מקצוע</option>
                <option value="english">אנגלית</option>
                <option value="math">מתמטיקה</option>
                <option value="exam-prep">הכנה למבחנים</option>
                <option value="confidence">בניית ביטחון בלימודים</option>
                <option value="other">אחר</option>
              </select>
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="ספרו לי קצת על התלמיד/ה ומה אתם מחפשים..."
                value={formData.message}
                onChange={handleChange}
                rows="4"
              ></textarea>
            </div>
            <button type="submit" className="submit-button">שלחו הודעה</button>
          </form>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="שלחו הודעה בווטסאפ"
      >
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </a>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>© {new Date().getFullYear()} לינוי חרוש - מורה פרטית | כל הזכויות שמורות</p>
          <p>
            <a
              href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-whatsapp"
            >
              📞 052-599-5052
            </a>
          </p>
          <p className="powered-by">
            Powered by{' '}
            <a
              href="https://www.itaysolutions.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ItaySolutions
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
